import { RightOutlined } from '@ant-design/icons';
import { List } from 'antd';
import TextRegular from 'containers/DriverPortalPage/components/TextRegular';
import { useIsWebView } from 'hooks/useIsWebView';
import { useQueryParams } from 'hooks/useQueryParams';
import React from 'react';
import { theme } from '../../../../../configs/styled';
import { IMenuItem } from '../../../../../services/driverPortal/main/MainService.interface';
import DocumentStatus from '../DocumentStatus';
import './Item.css';
interface IMenuItemProps {
  item: IMenuItem;
}

const MenuItem: React.FC<IMenuItemProps> = props => {
  const { item } = props;

  const { search, pushUrl } = useQueryParams();
  const isWebView = useIsWebView();

  const handleClickItem = (item: IMenuItem) => {
    if (!item.disabled) {
      pushUrl(`${item.path}`, search);
    }
  };

  return (
    <List.Item onClick={() => handleClickItem(item)}>
      <List.Item.Meta
        style={{
          alignItems: 'center',
          marginBottom: 0,
          opacity: item.disabled ? 0.4 : 1,
          cursor: item.disabled ? 'default' : 'pointer',
        }}
        title={
          <>
            {item.required && !isWebView && (
              <TextRegular color={theme.palettes.red}>* </TextRegular>
            )}
            <TextRegular color={theme.palettes.black85}>
              {item.title}
            </TextRegular>
            {!item.required && !isWebView && !item.defaultre && (
              <TextRegular> (ไม่บังคับ)</TextRegular>
            )}
          </>
        }
        description={
          <>
            {item.description && (
              <TextRegular fontSize={theme.fontSize.xxxs}>
                {item.description}
              </TextRegular>
            )}
          </>
        }
      />
      {!item.disabled && (
        <>
          <DocumentStatus statusName={item.status ?? ''} />
          <RightOutlined />
        </>
      )}
    </List.Item>
  );
};

export default MenuItem;
